<template>
    <div class="movies">
      <div v-for="item in data.Search" class="movie" v-bind:key="item.imdbID">
        <a v-on:click="$emit('open-movie', item.imdbID)" class="image" target="_blank">
          <img v-if="item.Poster != 'N/A'" v-bind:src="item.Poster">
        </a>
        <div v-if="item.Poster != 'N/A'" class="about">
          <span class="title">
            <a v-on:click="$emit('open-movie', item.imdbID)" class="title" target="_blank" >
              {{ item.Title }}
            </a>
          </span>
          <div>
            {{ item.Year }}
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'Movies',
    props: ["data"]
}
</script>

<style scoped>

.movie {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5%;
  margin-bottom: 5%;
}

.movie img {
  width: 200px;
  margin-right: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: 0.5s all;
}

.movie img:hover {
  opacity: 0.9;
}

.movie .about {
  width: 250px;
  margin-left: 10px;
}

.movie a {
  color: #1C2833;
  text-decoration: none;
  font-weight: bold;
  font-size: 24px;
  transition: 0.5s all;
}

.movies a:hover {
    opacity: 0.7;
    cursor: pointer;
}

.movies {
  min-height: calc(100vh - 33px - 37px)
}

@media only screen and (max-width: 580px) {
  .movies {
    margin-top: 12.5%;
  }

  .movie {
    margin-left: 5%;
  }

  .movie img {
    width: 180px;
  }

  .about {
    width: 120px;
  }

  .movie .title {
    font-size: 20px;
  }
}


</style>